/** Superficie pública de shared/dev. */
export { isDebugServiceFetches, debugServiceFetchWarn } from './debugServiceFetches';
export { devLog, devInfo, devWarn, silenceConsoleInProduction } from './devLog';
export {
  homeDbg,
  homeDbgRender,
  homeDbgTimed,
  homeDbgStartPointerProbe,
  isHomeDebugEnabled,
} from './homeDebug';
export { recordNetworkCall, recordStartupNetworkCall, logSessionNetworkSummary, resetNetworkCallAudit } from './networkCallAudit';
export type { NetworkCallClass, NetworkCallCategory, NetworkCallEntry } from './networkCallAudit';
export { markBoot, resetBootTiming } from './bootTiming';
export { isPlaywrightE2E, isPlaywrightE2EBridge } from '../playwrightE2e';
